import script from "./qbankAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./qbankAnswer.vue?vue&type=script&setup=true&lang=js"

import "./qbankAnswer.vue?vue&type=style&index=0&id=95250c0e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95250c0e"]])

export default __exports__